export const SLICE_NAME = 'google';
